import type { ConsultationStatus } from '@shared/patient-intake-status';

// FUTURE: make this input type safe - we should know the possible status types
export const parseConsultationStatus = (status: string): ConsultationStatus | null => {
  switch (status) {
    case 'awaiting review':
      return 'AWAITING_REVIEW';

    case 'in progress':
    case 'awaiting payment':
      return 'IN_PROGRESS';

    case 'not started':
      return 'NOT_STARTED';

    case 'awaiting script':
    case 'consult complete':
      return 'CONSULT_COMPLETE';

    default:
      return null;
  }
};
